import React, { memo } from "react";
import { string, bool } from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";

import style from "./style.module.scss";
import { COMPARED_STATUS } from "./utils";

const STATUS_TEXT = {
  [COMPARED_STATUS.PENDING]: { icon: "⏳", text: "Chờ so sánh", short: "…" },
  [COMPARED_STATUS.PROCESSING]: { text: "Đang so sánh", short: "⟳" },
  [COMPARED_STATUS.FAILED]: { icon: "⚠", text: "Lỗi so sánh", short: "⚠" },
};

export default memo(CompareStatus);

CompareStatus.propTypes = {
  status: string,
  compact: bool,
};

// Non-completed comparison state (pending / processing / failed / unknown)
function CompareStatus({ status, compact }) {
  const config = STATUS_TEXT[status] || { text: "Chưa có kết quả", short: "-" };
  const isError = status === COMPARED_STATUS.FAILED;

  if (compact) return config.short;

  return (
    <div
      className={`${style.compareStatus} ${
        isError ? style.compareStatusError : ""
      }`}
    >
      {status === COMPARED_STATUS.PROCESSING ? (
        <CircularProgress size={12} />
      ) : (
        config.icon
      )}
      <span>{config.text}</span>
    </div>
  );
}
